import { useContext } from 'react';
import ddt from '@wix/da-ddt';
import { useLayoutEffectWithoutSSRComplaining } from '@wix/da-hooks/pkg/useLayoutEffectWithoutSSRComplaining';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { DuperbrowseStreamContext } from '../DuperbrowseStreamContextProvider/DuperbrowseStreamContext';
import { scrollIntoViewInViewportCenter } from '../../utils/scrollIntoViewWithHeader';
function useDuperbrowseScrollRestoration(itemIds, ref, isEnabled = true) {
    const { stream , lastViewedItem  } = useContext(DuperbrowseStreamContext);
    const isMobile = useContext(MobileContext);
    const wasLastItemOpened = !!lastViewedItem && // if we have a just-closed stream
    lastViewedItem.streamId === stream.streamId && // and it's our current stream
    itemIds.includes(lastViewedItem.itemId); // and its last viewed item was this one
    useLayoutEffectWithoutSSRComplaining(()=>{
        isEnabled && lastViewedItem && ddt.log('duperscroll', `Items: ${itemIds.join(';')} wasLastViewed: ${wasLastItemOpened} (${lastViewedItem === null || lastViewedItem === void 0 ? void 0 : lastViewedItem.streamId}, ${lastViewedItem === null || lastViewedItem === void 0 ? void 0 : lastViewedItem.itemId})`);
        // then restore scroll position to ourselves
        if (isEnabled && wasLastItemOpened && ref.current) {
            scrollIntoViewInViewportCenter(ref.current, isMobile);
        }
    }, [
        wasLastItemOpened,
        isMobile,
        isEnabled
    ]);
}
export default useDuperbrowseScrollRestoration;
